import React, { useState, useEffect } from "react";
import { useData } from "../context/DataContext";
import { useAuth } from "../context/AuthContext";
import { reportsAPI } from "../api";

export default function ReportsScreen() {
    const { reports, refreshReports } = useData();
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState("unpaid");

    const unpaidReports = reports.filter((r) => r.paid === 0);
    const archiveReports = reports.filter((r) => r.paid === 1);
    const currentData = activeTab === "unpaid" ? unpaidReports : archiveReports;

    // Загружаем отчёты при монтировании
    useEffect(() => {
        refreshReports();
    }, [refreshReports]);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            alert("Скопировано в буфер обмена");
        } catch (err) {
            alert("Не удалось скопировать");
        }
    };

    const handleMarkAsPaid = async (orderId) => {
        if (!user?.uid_master) {
            alert("Данные пользователя отсутствуют");
            return;
        }
        try {
            await reportsAPI.markOrderAsPaid(orderId, user.uid_master);
            refreshReports();
            alert("Заказ отмечен как оплаченный");
        } catch (error) {
            console.error(error);
            alert("Не удалось отметить оплату");
        }
    };

    return (
        <div className="px-4 pt-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Отчёты</h2>
            <div className="flex mb-4">
                <button
                    onClick={() => setActiveTab("unpaid")}
                    className={`flex-1 py-2 rounded-l-full font-medium ${activeTab === "unpaid" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"}`}>
                    Неоплаченные ({unpaidReports.length})
                </button>
                <button
                    onClick={() => setActiveTab("archive")}
                    className={`flex-1 py-2 rounded-r-full font-medium ${activeTab === "archive" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"}`}>
                    Архив ({archiveReports.length})
                </button>
            </div>

            {currentData.length === 0 ? (
                <div className="text-center text-gray-500 py-10">{activeTab === "unpaid" ? "Нет неоплаченных отчётов" : "Нет отчётов в архиве"}</div>
            ) : (
                currentData.map((item) => (
                    <div key={item.id} className="bg-white p-4 mb-3 rounded-xl shadow-sm border border-gray-100">
                        <div className="text-lg font-semibold text-gray-800">№ {item.orderNumber}</div>
                        <div className="text-gray-600">
                            {item.title} {item.brand}
                        </div>
                        {item.repairSum && <div className="text-gray-600">Общий чек: {item.repairSum} ₽</div>}
                        {item.spareSum && <div className="text-gray-600">Стоимость запчастей: {item.spareSum} ₽</div>}
                        {item.amountSum && <div className="text-gray-600">Стоимость работ: {item.amountSum} ₽</div>}
                        {activeTab === "unpaid" && (
                            <>
                                {item.commissionSum && <div className="text-gray-600 font-semibold">Комиссия: {item.commissionSum} ₽</div>}
                                {(item.cardBank || item.cardNumber || item.cardFio) && (
                                    <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                                        <div className="text-sm font-medium text-blue-800 mb-1">Реквизиты для оплаты:</div>
                                        {item.cardBank && <div className="text-sm text-gray-700">Банк: {item.cardBank}</div>}
                                        {item.cardNumber && (
                                            <div className="flex items-center justify-between mt-1">
                                                <span className="text-sm text-gray-700">Карта: {item.cardNumber}</span>
                                                <button onClick={() => copyToClipboard(item.cardNumber)} className="text-blue-600 text-sm font-medium ml-2">
                                                    Копировать
                                                </button>
                                            </div>
                                        )}
                                        {item.cardFio && <div className="text-sm text-gray-700">Владелец: {item.cardFio}</div>}
                                    </div>
                                )}
                            </>
                        )}
                        {item.comment && <div className="text-gray-600">Комментарий: {item.comment}</div>}
                        {item.photos && item.photos.length > 0 && (
                            <div className="flex mt-2 space-x-2">
                                {item.photos.map((uri, idx) => (
                                    <img key={idx} src={uri} alt="фото" className="w-16 h-16 rounded-lg object-cover" />
                                ))}
                            </div>
                        )}
                        {item.completedAt && <div className="text-gray-400 text-xs mt-2">Выполнен: {new Date(item.completedAt).toLocaleDateString()}</div>}
                        {activeTab === "unpaid" && (
                            <button onClick={() => handleMarkAsPaid(item.orderNumber)} className="w-full bg-green-500 py-3 rounded-full mt-4 text-white font-medium">
                                Оплатил
                            </button>
                        )}
                    </div>
                ))
            )}
        </div>
    );
}
